import { Grid } from "@mui/material";
import { Works } from "./works/Works";
import { PkCommonFooter } from "../../components/common/PkCommonFooter";
import { PkCommonHeader } from "../../components/common/PkCommonHeader";
export function PrivacyPage() {
  return (
    <Grid container sx={{ width: "100%" }}>
      <Grid xs={12} item>
        <PkCommonHeader />
      </Grid>
      <Grid xs={12} item>
        <Works />
      </Grid>
      <Grid xs={12} item>
        <PkCommonFooter />
      </Grid>
    </Grid>
  );
}
